<template>
    <v-sheet>
        <v-sheet>
            <h5 class="page-text--lg mb-12 mb-lg-20">
                {{ meeting?.title || "" }}
            </h5>
            <div class="schedule-items">
                <div v-for="date in dates" :key="date.text" class="schedule-item">
                    <p class="page-text--lg font-weight-medium mb-8 mb-lg-16">
                        {{ date.text }}
                    </p>
                    <v-row class="row--small">
                        <v-col v-for="time in date.times" :key="`${date.text} ${time.text}`" cols="4" md="3" lg="2">
                            <v-btn block outlined :color="time.isActive ? 'primary' : 'grey-9'" :class="time.isActive ? '' : 'grey-6--text'" :elevation="time.isActive ? 1 : undefined" v-on="toggle(time)">
                                <v-row no-gutters align="center">
                                    <v-col class="text-start"> {{ time.text }} </v-col>
                                    <v-col v-if="mode == 'form'" cols="auto">
                                        <v-simple-checkbox :value="time.isActive" v-on="toggle(time)" color="primary" />
                                    </v-col>
                                </v-row>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-sheet>
    </v-sheet>
    <!-- <v-card outlined rounded="xl" style="overflow-y: auto" class="pa-24">
        <v-card-title class="pa-0 mb-20 mb-md-40 font-size-16 font-size-lg-20">{{ meeting?.title || "" }}</v-card-title>
        <v-sheet v-for="date in dates" :key="date.text">
            <v-card-subtitle class="pa-0 mb-16 page-text--lg" style="color: #131313;">{{ date.text }}</v-card-subtitle>
            <v-card-text class="pa-0">
                <v-row class="row--small mb-20 mb-md-40">
                    <v-col cols="6" sm="4" md="2" class="py-8" v-for="time in date.times" :key="`${date.text} ${time.text}`">
                        <v-btn block outlined rounded :color="time.isActive ? 'primary' : 'grey darken-1'" :elevation="time.isActive ? 1 : undefined" v-on="toggle(time)">
                            <v-row no-gutters align="center">
                                <v-col class="text-start"> {{ time.text }} </v-col>
                                <v-col v-if="mode == 'form'" cols="auto">
                                    <v-simple-checkbox :value="time.isActive" v-on="toggle(time)" />
                                </v-col>
                            </v-row>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-sheet>
    </v-card> -->
</template>

<script>
import dayjs from "dayjs";
import { initMeeting } from "@/assets/variables";

export default {
    props: {
        mode: { type: String, default: "view" },
        value: { type: String }, // date
        meeting: { type: Object, default: initMeeting },
    },
    computed: {
        dates() {
            return (this.meeting?.schedulesAvailable || [])
                .reduce((dates, time) => {
                    let date = time.toDate();
                    let dateObject = dates.find((item) => item.date == date);
                    if (!dateObject) {
                        dateObject = { date, times: [] };
                        dates.push(dateObject);
                    }
                    dateObject.times.push({ time });
                    return dates;
                }, [])
                .map((dateItem) => ({
                    ...dateItem,
                    text: dayjs(dateItem.date).format("YYYY년 MM월 DD일 (dd)"),
                    times: dateItem.times.map((timeItem) => ({
                        ...timeItem,
                        text: dayjs(timeItem.time).format("a hh:mm"),
                        isActive: this.value == timeItem.time,
                    })),
                }));
        },
    },
    methods: {
        toggle({ time }) {
            console.log({ time });
            if (this.mode == "form") {
                console.log(this.value != time ? time : null);
                return { click: () => this.$emit("input", this.value != time ? time : null) };
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.schedule-items{
    .schedule-item:not(:last-child){
        margin-bottom: 20px;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .schedule-items{
    .schedule-item:not(:last-child){
        margin-bottom: 40px;
    }
}
}
@media (min-width:1200px){
}
::v-deep{
    .v-btn:not(.v-btn--fab,.v-btn--icon,.v-btn--text).v-size--default{
        font-weight: 400;
        font-size: 1.4rem;
        padding: 0 16px;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    ::v-deep{
        .v-btn:not(.v-btn--fab,.v-btn--icon,.v-btn--text).v-size--default{
            font-size: 1.8rem;
            padding: 0 16px;
        }
    }
}
@media (min-width:1200px){
}

</style>
